import script from "./Invitevst.vue?vue&type=script&setup=true&lang=js"
export * from "./Invitevst.vue?vue&type=script&setup=true&lang=js"

import "./Invitevst.vue?vue&type=style&index=0&id=6d4f8fd0&lang=less"

const __exports__ = script;

export default __exports__